import React, { useState, useEffect } from "react";
import "./ClassFeedback.css";
import { MoonLoader, PulseLoader } from "react-spinners";
import { Formik } from "formik";
import * as Yup from "yup";
import { styled } from "@mui/material/styles";
import Rating from "@mui/material/Rating";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
import TextArea from "../../../Components/Atoms/Inputs/TextArea/TextArea";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { useNavigate } from "react-router-dom";
import DeleteForm from "../../../Components/Molecules/DeleteForm/DeleteForm";
import { classesURL } from "../../../Hooks/URL";
import useDelete from "../../../Hooks/useDelete";

const StyledRating = styled(Rating)(({ theme }) => ({
  "& .MuiRating-iconEmpty .MuiSvgIcon-root": {
    color: theme.palette.action.disabled,
  },
}));

const customIcons = {
  1: {
    icon: (
      <SentimentVeryDissatisfiedIcon color="error" className="reportIcon" />
    ),
    label: "Poor",
  },
  2: {
    icon: <SentimentDissatisfiedIcon color="error" className="reportIcon" />,
    label: "Fair",
  },
  3: {
    icon: <SentimentSatisfiedIcon color="warning" className="reportIcon" />,
    label: "Good",
  },
  4: {
    icon: <SentimentSatisfiedAltIcon color="success" className="reportIcon" />,
    label: "Very Good",
  },
  5: {
    icon: <SentimentVerySatisfiedIcon color="success" className="reportIcon" />,
    label: "Excellent",
  },
};

function IconContainer(props) {
  const { value, ...other } = props;
  return (
    <span
      {...other}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <span>{customIcons[value].icon}</span>
      <span className="ratingLabel">{customIcons[value].label}</span>
    </span>
  );
}

function ClassFeedback({ feedback, loading, classId, student }) {
  const navigate = useNavigate();
  const [go, setGo] = useState(false);
  const { loading: deleteLoading } = useDelete(
    `${classesURL}/${classId}/class-feedbacks/${feedback?.classFeedback?.id}/feedbacks/${feedback?.id}`,
    go,
    `classes/${classId}/reports/${feedback?.classFeedback?.id}`
  );

  if (loading) {
    return (
      <div className="mainContainer">
        <div className="loadingContainer">
          <MoonLoader color="#012369" size={40} />
        </div>
      </div>
    );
  }

  return (
    <div className="mainContainer">
      <div className="contentSection modernFormWrapper">
        {/* Header */}
        <div className="courseHeader">
          <div className="titleIcon">
            <AssessmentIcon />
          </div>
          <div className="courseBasicInfo">
            <h1 className="courseName">{student?.name} Report</h1>
          </div>

          <button
            className="actionButton primary"
            onClick={() =>
              navigate(
                `/classes/${classId}/reports/${feedback?.classFeedback?.id}/student/${student?.id}/feedback/${feedback?.id}/edit`
              )
            }
          >
            Edit Feedback
          </button>
          <DeleteForm
            setGo={setGo}
            title={`Are you sure to delete this feedback?`}
            buttonText={"Delete Feedback"}
          />
        </div>

        {feedback?.attributes && !loading ? (
          <>
            <div className="lessonsHeader">
              <h2 className="sectionTitle">Performance Attributes</h2>
            </div>

            <div className="attributesContainer">
              {feedback?.attributes?.length
                ? feedback?.attributes?.map((item) => (
                    <div
                      key={item?.courseAttribute?.id}
                      className="attributeCardFeedback"
                    >
                      <div className="attributeHeader">
                        <h3 className="attributeNameFeedback">
                          {item?.courseAttribute?.attribute}
                        </h3>
                      </div>
                      <div className="ratingContainer">
                        <StyledRating
                          name={`rating-${item?.courseAttribute?.id}`}
                          IconContainerComponent={IconContainer}
                          value={item?.value}
                          highlightSelectedOnly
                          getLabelText={(value) => "Hello"}
                          disabled
                        />
                      </div>
                    </div>
                  ))
                : ""}
            </div>

            {/* Notes Section */}
            <div className="notesSection">
              <div className="lessonsHeader">
                <h2 className="sectionTitle">Notes:</h2>
              </div>
              <TextArea
                style={{ marginBottom: "10px" }}
                classes="textAreaInput"
                label={"Notes"}
                name={"description"}
                newValue={feedback?.description}
                readOnly
              />
            </div>
          </>
        ) : (
          <div className="loadingContainer">
            <MoonLoader color="#012369" size={40} />
          </div>
        )}
      </div>
    </div>
  );
}

export default ClassFeedback;
